

































import Vue from 'vue'
import { AppMenuServiceProxy, AppMenuInputDTO } from '@/service-proxies/app-v2/system.service-proxies'
import AddMenu from './AddMenu.vue'
import { DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

const dictService = new DictServiceProxy()
const appMenuServiceProxy = new AppMenuServiceProxy()
const columns = [
  {
    title: '菜单描述',
    dataIndex: 'attribute.name',
    key: 'attribute.name',
    wdith: 200,
    ellipsis: true,
  },
  {
    title: '菜单图标',
    dataIndex: 'attribute.source',
    key: 'attribute.source',
    scopedSlots: { customRender: 'icon' },
    ellipsis: true,
    width: 80,
    align: 'center',
  },
  {
    title: '菜单属性',
    dataIndex: 'kindName',
    key: 'kindName',
    ellipsis: true,
    width: 100,
  },
  {
    title: '菜单排序',
    dataIndex: 'attribute.sort',
    key: 'attribute.sort',
    ellipsis: true,
    width: 70,
    align: 'right',
  },
  {
    title: '菜单编号（多语言键）',
    dataIndex: 'attribute.code',
    key: 'attribute.code',
    ellipsis: true,
    width: 200
  },
  {
    title: '路由地址',
    dataIndex: 'attribute.path',
    key: 'attribute.path',
    ellipsis: true,
    width: 120,
  },
  {
    title: '备注',
    dataIndex: 'attribute.remark',
    key: 'attribute.remark',
    ellipsis: true,
  },
]

export default Vue.extend({
  components: {
    AddMenu,
  },
  data() {
    return {
      columns,
      data: [],
      visible: false,
      loading: false,
      menuKind: {},
    }
  },
  props: {
    app: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    menuIds() {
      let res = []
      this.getCheckMenuIds(this.data, res)
      return res
    },
  },
  watch: {
    app() {
      this.getDictionary()
    },
  },
  created() {
    this.getDictionary()
  },
  methods: {
    getCheckMenuIds(data, temp) {
      data.map(item=>{
        temp.push(item.id)
        if(item.children) {
          this.getCheckMenuIds(item.children, temp)
        }
      })
    },
    getDictionary() {
      this.menuKind = {}
      dictService.dictionary('menu_kind').then(res => {
        if (res) {
          let menuKind = {}
          res.data.map(item => {
            menuKind[item.dictKey] = item.dictValue
          })
          this.menuKind = menuKind
          this.loadMenuList()
        }
      })
    },
    loadMenuList() {
      if (this.app.id) {
        this.data = []
        this.loading = true
        appMenuServiceProxy.appId(this.app.id).then(res => {
          this.loading = false
          this.data = this.handleTableData(res)
        })
      }
    },
    handleTableData(data) {
      data.map(item => {
        item.kindName = this.menuKind[item.attribute.kind]
        if (!item.children.length) {
          delete item.children
        } else {
          this.handleTableData(item.children)
        }
      })
      return data
    },
    addMenuBack(flag: Boolean) {
      this.visible = false
      if (flag) {
        this.loadMenuList()
      }
    },
    openEdit() {
      this.visible = true
    },
  },
})
